import axiosInstance from '../../plugins/axios';

const getConditionDetails = async (conditionId) => {
  const res = await axiosInstance.get(`/conditions/${conditionId}`);
  return { data: res.data, errorMessage: null };
}

const evaluateTerm = (term, answers, allFlags) => {
  const variableResults = term.variables.map(variable => evaluateVariable(variable, answers, allFlags));
  const validVariableResults = variableResults.filter(res => res.result);

  const subtermResults = term.subterms.map(subterm => evaluateTerm(subterm, answers, allFlags));
  const validSubtermResults = subtermResults.filter(res => res.result);

  const allResults = [...validVariableResults, ...validSubtermResults];

  if (term.operator === 'AND') {
    const allValid = allResults.length === (term.variables.length + term.subterms.length);
    return { result: allValid, errorMessage: allValid ? null : "Not all conditions met" };
  } else if (term.operator === 'OR') {
    const anyValid = allResults.length > 0;
    return { result: anyValid, errorMessage: anyValid ? null : "No valid options selected" };
  }

  return { result: false, errorMessage: "Unsupported operator" };
}

const evaluateVariable = (variable, answers, allFlags) => {
  console.log(`[[EVALUATE VARIABLE]] - Evaluating variable: ${variable.id}, type: ${variable.type}, negated: ${variable.negated}`);
  
  if (variable.type === 'flag') {
    const flag = allFlags.find(flag => flag.id === variable.id);
    if (!flag) {
      return { result: false, errorMessage: `Flag not found for variable id: ${variable.id}` };
    }
    const result = variable.negated ? !flag.currentValue : flag.currentValue;
    return { result, errorMessage: null };
  } else if (variable.type === 'option') {
    const lastAnswer = answers[answers.length - 1];
    const optionFound = lastAnswer && lastAnswer.selectedOptions.some(option => option.id === variable.id);
    const result = variable.negated ? !optionFound : optionFound;
    return { result, errorMessage: result ? null : `Answer not found for variable id: ${variable.id}` };
  }

  return { result: false, errorMessage: "Invalid variable type" };
}



const evaluateCondition = async (condition, answers, allFlags, questionType) => {
  const { data: cond, errorMessage } = await getConditionDetails(condition);
  if (errorMessage) return { nextFieldId: null, errorMessage };

  let allTermsMet = true;
  let firstMatchingNextFieldId = null;
  let matchedChangeFlags = [];

  for (const term of cond.terms) {
    const { result: termResult, errorMessage: termError } = evaluateTerm(term, answers, allFlags);
    if (termResult) {
      if (!firstMatchingNextFieldId) {
        firstMatchingNextFieldId = cond.nextFieldId;
      }
      matchedChangeFlags = [...matchedChangeFlags, ...cond.changeFlags];
    } else {
      allTermsMet = false;
    }
  }

  return { nextFieldId: allTermsMet ? firstMatchingNextFieldId : null, changeFlags: allTermsMet ? matchedChangeFlags : [], errorMessage: null };
}

export const determineNextQuestion = async (question, answers, allFlags) => {
  let firstNextFieldId = null;
  let accumulatedChangeFlags = [];
  
  for (const condition of question.conditions) {
    const { nextFieldId, changeFlags, errorMessage } = await evaluateCondition(condition, answers, allFlags, question.type);
    if (errorMessage) {
      continue; 
    }

    if (nextFieldId && !firstNextFieldId) {
      firstNextFieldId = nextFieldId; 
    }

    if (changeFlags && changeFlags.length > 0) {
      accumulatedChangeFlags = [...accumulatedChangeFlags, ...changeFlags];
    }
  }

  if (firstNextFieldId === "evaluation") {
    return { nextQuestion: "evaluation", changeFlags: accumulatedChangeFlags, errorMessage: null };
  }

  if (firstNextFieldId) {
    const { data: nextQuestion, errorMessage: nextQuestionError } = await axiosInstance.get(`/questions/${firstNextFieldId}`);
    if (nextQuestionError) {
      return { nextQuestion: null, errorMessage: nextQuestionError }; 
    }
    return { nextQuestion: nextQuestion, changeFlags: accumulatedChangeFlags, errorMessage: null }; 
  }

  return { nextQuestion: null, errorMessage: 'No conditions met for question' }; 
};

export default determineNextQuestion;
